import { RouteInterface } from '@/src/common/enums/routes'

export const UpdatesRoutes = {} as const satisfies Record<string, RouteInterface>
